import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import SEO from '../../components/SEO';
import { blogPosts } from '../../content/blogPosts';

const Blog = () => {
  return (
    <main>
      <SEO
        title="Blog | Keyif"
        description="Read the latest stories, guides, and tips from the Keyif blog."
      />
      <Header />
      <section className="blog-list">
        <h1>Keyif Blog</h1>
        <p>
          Stories, guides, and tips to help you get more visibility and results
          with Keyif.
        </p>
        <ul>
          {blogPosts.map((post) => (
            <li key={post.slug} className="blog-list-item">
              <h2>
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="blog-list-date">{post.date}</p>
              <p className="blog-list-description">{post.description}</p>
              <Link to={`/blog/${post.slug}`}>Read more</Link>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default Blog;
